import { MediaIntegrationId } from 'components/VideoTemplateEditor/types/core';
import { ImageOriginId, KeyImageType, SourceImageOrigin } from 'types';
import { Slide } from '../types';
import { SlideExport } from './types';

// TODO do we still need this?
export function getSourceImageOrigin(slide: Slide): SourceImageOrigin {
  const integrationData = slide?.integrationData;
  if (integrationData?.id === MediaIntegrationId.CANVA) {
    return {
      origin: ImageOriginId.CANVA,
      canvaDesignId: integrationData.designId,
    };
  }

  return undefined;
}

export function isDynamicSlideExport(slide: SlideExport | Slide): boolean {
  return slide.integrationData?.id === MediaIntegrationId.DYNAMIC;
}

export function getImageTypeForSlideExport(
  slide: SlideExport | Slide,
): KeyImageType | undefined {
  return isDynamicSlideExport(slide) ? 'mainImage' : slide.imageType;
}
